import React from 'react'
import classnames from 'classnames'
import { Card } from 'antd'
import './style.overwrite.scss'

export default function CardBoxShadow({ children, className }) {
  return <Card className={classnames('card-box-shadow', className)}>{children}</Card>
}
